/** @jsx h */
import { h, Component, JSX } from 'preact';
import classNames from 'classnames';
import cssStyles from './index.css';
import { WrappedHtml } from '../../lib/wrapped-html';
import { RootStore } from '../../../../common/js/stores/root.store';
import { logMessage } from '../../../../common/js/sentry';
import { EndScreenType } from '../../lib/end-screen/end-screen-types';
import { EndScreen } from '../../lib/end-screen/end-screen';

interface VideoEndScreenHtmlProps {
  endScreen: EndScreen;
  onClick?: (source: string, event?: MessageEvent) => void;
}

export default class VideoEndScreenHtml extends Component<
  VideoEndScreenHtmlProps
> {
  iframeRef: HTMLIFrameElement | null = null;

  constructor(props: VideoEndScreenHtmlProps) {
    super(props);
    this.listenClickFromIframe();
  }

  listenClickFromIframe(): void {
    const messageListener = (event: MessageEvent) => {
      if (event.data === 'clickFromIframe') {
        removeMessageListener();
        this.props.onClick && this.props.onClick('endScreen', event);
      }
    };

    function removeMessageListener() {
      window.removeEventListener('message', messageListener, false);
    }

    window.addEventListener('message', messageListener, false);
  }

  shouldComponentUpdate(): boolean {
    return false;
  }

  componentDidMount(): void {
    this.injectDOM();
  }

  injectDOM(): void {
    const { content, type } = this.props.endScreen;
    const windowIframe = this.iframeRef && this.iframeRef.contentWindow;
    if (windowIframe) {
      (windowIframe as any).mraid = (window as any).mraid;
      if (type === EndScreenType.HTML) {
        this.injectContent(windowIframe.document, content as string);
      } else if (type === EndScreenType.IFRAME) {
        fetch(content as string)
          .then(response => response.text())
          .then(data => this.injectContent(windowIframe.document, data))
          .catch(() => {
            logMessage(
              'Fail to fetch iframe to set the end screen with this url : ' +
                content
            );
            RootStore.getInstance().adContainerStore.unloadFormat();
          });
      }
    }
  }

  injectContent(document: Document, content: string): void {
    const srcDoc = new WrappedHtml(content).content;
    document.open();
    document.write(srcDoc);
    document.close();
  }

  render(): JSX.Element {
    return (
      <iframe
        ref={(iframeRef: HTMLIFrameElement | null) =>
          (this.iframeRef = iframeRef)
        }
        className={classNames(cssStyles.endScreen, cssStyles.endScreenHtml)}
        frameBorder={'0'}
        marginWidth={0}
        marginHeight={0}
        scrolling="no"
        id="end_screen_html"
      />
    );
  }
}
